import { Component } from '@angular/core'

@Component( {
  selector: 'app-header',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent {
}
